var _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSec4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 63.7014,
    width: 90.0453,
    height: 90.0453,
    rx: 37,
    transform: "rotate(-45 0 63.7014)",
    fill: "#000466",
    fillOpacity: 0.69
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.152 48.3244C102.629 48.3244 101.29 48.9267 99.8589 49.6217C95.3345 51.8922 83.7927 58.3791 82.5923 58.5645C79.8685 56.9427 77.1446 55.3673 74.3284 53.8382C71.5122 52.3092 69.8502 51.3825 67.4957 50.2705C65.1411 49.1584 62.7404 47.6757 60.2012 48.0463C57.662 48.417 56.277 50.5485 56.277 52.7726L56 97.8105C56.0118 99.1137 56.5298 100.361 57.4437 101.287C58.3576 102.213 59.5954 102.744 60.8937 102.768C61.5402 102.774 62.1816 102.652 62.7806 102.408C63.3797 102.164 63.9247 101.803 64.384 101.346C64.8433 100.89 65.2079 100.346 65.4567 99.7471C65.7055 99.1482 65.8337 98.5057 65.8336 97.8568L65.9721 76.1256L82.5462 66.9048L99.0741 76.3109L98.9355 98.0421C98.8659 98.73 98.9404 99.4249 99.1541 100.082C99.3679 100.739 99.7163 101.345 100.177 101.859C100.638 102.373 101.2 102.784 101.829 103.067C102.457 103.35 103.138 103.498 103.827 103.501C104.516 103.505 105.198 103.363 105.829 103.086C106.46 102.809 107.027 102.403 107.492 101.893C107.958 101.383 108.312 100.782 108.531 100.126C108.751 99.4711 108.832 98.7769 108.769 98.0885L109 53.0969C109.042 52.087 108.747 51.0919 108.161 50.2694C107.576 49.4469 106.734 48.844 105.768 48.5561C105.241 48.4143 104.698 48.3365 104.152 48.3244V48.3244ZM66.0645 57.3134L76.7753 62.781L66.0183 68.7119L66.0645 57.3134ZM88.4094 62.8736L99.1664 57.4987V68.8972L88.4094 62.8736Z",
    fill: "#C48C2D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_154_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2208 41.8352L41.6037 16.5329C42.2111 15.2551 42.2994 13.7966 41.85 12.4615C41.4007 11.1264 40.4485 10.0176 39.1918 9.3662C37.9352 8.71481 36.471 8.57107 35.1044 8.96494C33.7379 9.3588 32.5743 10.2599 31.8563 11.4804L16.0863 41.2062C15.4324 42.6243 15.3269 44.2289 15.79 45.7133C16.2531 47.1976 17.2523 48.4576 18.5965 49.2523L48.4715 64.7379C49.1102 65.0758 49.8109 65.2837 50.5329 65.3496C51.2549 65.4156 51.9837 65.3381 52.6768 65.1219C53.3699 64.9057 54.0134 64.555 54.5698 64.0902C55.1263 63.6254 55.5845 63.0559 55.9178 62.4149V62.4149C56.2619 61.7748 56.4751 61.074 56.5448 60.3531C56.6146 59.6322 56.5396 58.9055 56.3242 58.2151C56.1088 57.5247 55.7573 56.8842 55.29 56.3309C54.8227 55.7775 54.2489 55.3222 53.6018 54.9914L28.2208 41.8352Z",
    fill: "#C48C2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 55,
    fill: "white",
    transform: "translate(56 48)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_154_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 59,
    fill: "white",
    transform: "translate(7.00842 17.5505) rotate(-17.3267)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec4);
export default __webpack_public_path__ + "static/media/sec4.dbb0869f91bdb3637d977a5cf07fecbb.svg";
export { ForwardRef as ReactComponent };